export default __webpack_public_path__ + "static/media/528hz-dna-repair.64f3281e.mp3";